
import React, { useContext } from "react";
import { AgTechUser, DefaultAgTechUser } from "./AgTechAuthData";
import { AgTechAppAuthConfiguration } from "./AgTechAuthConfiguration";

export type AgTechAuthContext = {
    getLoggedInUser: () => Promise<AgTechUser | null>,
    isUserAuthenticated: () => boolean,
    loginUser: () => any,
    onSuccessfulUserLogin: (props: AgTechUserLoginProps) => Promise<void>,
    logoutUser: () => Promise<void>,
    user: AgTechUser,
    config: AgTechAppAuthConfiguration
};

export const DefaultAgTechAuthContext: AgTechAuthContext = {
    getLoggedInUser: () => Promise.prototype.then(),
    isUserAuthenticated: () => false,
    loginUser: () => {
        console.error('Attempted to login with default auth context');
    },
    onSuccessfulUserLogin: async () => {},
    logoutUser: () => new Promise<void>(res => {
        console.error('Default auth context was used');
        res();
    }),
    user: DefaultAgTechUser,
    config: {} as any
};

export type AgTechUserLoginProps = {
    navigateToRoot: () => void
}

export const AuthContext = React.createContext<AgTechAuthContext>(DefaultAgTechAuthContext);

export const useAgTechAuthContext = () => useContext(AuthContext);